import * as React from "react"
import { SVGProps } from "react"

const TransitionLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    viewBox="0 0 289 218"
    width="100%"
    height="100%"
  >
    <path
      d="M152.129 87.465s-38.261.855-52.612 2.864c-14.35 2.01-22.706 3.165-15.855-.6 6.851-3.765.694-4.042-7.592-2.31-8.286 1.733-12.823-4.157-16.04-8.846a171 171 0 0 1-10.856-18.849c-3.843-7.691 4.42-10.763 18.841-7.599 14.42 3.164 36.571 18.663 49.927 18.64 13.355-.023 30.438-8.615 38.539-14.551 8.101-5.937 20.161-18.017 52.242-23.93 32.081-5.913 27.058 8.8 21.827 11.919-5.231 3.118-27.475 9.978-40.599 12.611-13.124 2.633-27.267 1.317-19.513-4.62 7.755-5.936 38.84-17.739 54.418-17.161a174.698 174.698 0 0 0 42.566-3.003c16.828-3.003 20.23 3.372 13.425 11.364-6.805 7.992-10.346-10.302-4.42-9.401 5.925.9 8.679 12.565 11.226 27.417 2.546 14.853-9.514 11.342-16.203-3.094-6.689-14.437-10.092-38.76-10.138-48.253-.047-9.493 9.49-16.746 16.202 6.237 6.713 22.982-4.004 33.215-12.777 38.112-8.772 4.897-53.885 24.345-73.513 26.424-19.628 2.079-39.766-4.943-47.497-6.93-7.731-1.986-13.749-11.156-6.342-13.35 7.407-2.194 52.867 0 67.426 0 14.559 0 21.943 5.82 14.027 7.738-66.755 19.402-82.633 69.294-135.083 86.711-23.008 7.645-65.459 20.026-80.226-15.592-14.768-35.617 38.562-67.308 71.407-31.159C107.78 144.402 83.894 211.41 12.3 217"
      stroke="#333030"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
  </svg>
)

export default TransitionLine